module.exports = __webpack_public_path__ + "img/banner5.a991424c.jpg";